import { AuthContext } from "contexts/AuthContext";
import { useContext } from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ element }) {
    const { userAcesso } = useContext(AuthContext);

    // if(!userAcesso) {alert('Faça Login para acessar essa página')}

    // Se o usuário não estiver autenticado, redireciona para a página de login
    return userAcesso ? element : <Navigate to="/" replace />;
}

export default ProtectedRoute;
